import React, { useState, useEffect } from 'react';
import { colors } from '../styles';
import { checkFavorite, addFavorite, removeFavorite } from '../services/favoritesService';

const styles = {
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
    width: '100%',
    padding: '0.75rem 1rem',
    backgroundColor: colors.surface,
    border: `1px solid ${colors.border}`,
    borderRadius: '10px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    fontSize: '0.875rem',
    fontWeight: 500,
    color: colors.textPrimary,
  },
  buttonDisabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
  buttonHover: {
    backgroundColor: colors.surfaceHover,
    borderColor: colors.accent,
  },
  buttonActive: {
    backgroundColor: colors.accentLight,
    borderColor: colors.accent,
    color: colors.accentHover,
  },
  star: {
    fontSize: '1.125rem',
  },
  starEmpty: {
    color: colors.textMuted,
  },
  starFilled: {
    color: '#fbbf24',
  },
};

export default function FavoriteButton({ perfilId, lugarId, onToggle }) {
  const [isFavorito, setIsFavorito] = useState(false);
  const [loading, setLoading] = useState(true);
  const [hovered, setHovered] = useState(false);
  const [favoriteId, setFavoriteId] = useState(null);

  // Verificar si es favorito al montar
  useEffect(() => {
    async function checkStatus() {
      setLoading(true);
      try {
        const result = await checkFavorite(lugarId, perfilId || 'general');
        setIsFavorito(result.isFavorite);
        if (result.favoriteId) {
          setFavoriteId(result.favoriteId);
        }
      } catch (err) {
        console.error('Error verificando favorito:', err);
        // Si falla, asumir que no es favorito
        setIsFavorito(false);
      } finally {
        setLoading(false);
      }
    }
    checkStatus();
  }, [lugarId, perfilId]);

  const handleClick = async () => {
    if (loading) return;

    setLoading(true);
    try {
      if (isFavorito && favoriteId) {
        await removeFavorite(favoriteId);
        setIsFavorito(false);
        setFavoriteId(null);
      } else {
        const result = await addFavorite(lugarId, perfilId || 'general');
        setIsFavorito(true);
        setFavoriteId(result.id);
      }
      if (onToggle) onToggle(!isFavorito);
    } catch (err) {
      console.error('Error toggling favorito:', err);
      // Podríamos mostrar un toast aquí
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      style={{
        ...styles.button,
        ...(loading ? styles.buttonDisabled : {}),
        ...(hovered && !loading ? styles.buttonHover : {}),
        ...(isFavorito ? styles.buttonActive : {}),
      }}
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      disabled={loading}
    >
      <span style={{
        ...styles.star,
        ...(isFavorito ? styles.starFilled : styles.starEmpty),
      }}>
        {loading ? '...' : isFavorito ? '★' : '☆'}
      </span>
      <span>
        {loading ? 'Cargando...' : isFavorito ? 'Guardado en favoritos' : 'Guardar en favoritos'}
      </span>
    </button>
  );
}
